<template>
    <div class="treports-pages">
        <PageTitle icon="mdi-chart-gantt" main="Consultoria"
            sub="Cadastros & Cia" />
                    
        <div class="treports-pages-tabs">
            <v-tabs
            background-color="indigo"
            slider-color="indigo lighten-5"
            v-model="tabActived"
            grow
            center-active
            dark
            icons-and-text
            >
                <v-tab
                    v-for="n in nav.length"
                    :key="n"
                    ripple
                    class="ma-0"
                    >
                    {{ nav[n-1].title }}
                    <v-icon>{{ nav[n-1].icon }}</v-icon>
                </v-tab>
                
                <v-tab-item
                    v-for="n in nav.length"
                    :key="n">
                    <v-card flat>
                        <v-card-text>
                            <keep-alive>
                                <Register 
                                    :title="nav[n-1].title"
                                    :scope="nav[n-1].scope"
                                    :path="nav[n-1].path"
                                    :segment="nav[n-1].segment"
                                    :query="nav[n-1].query"
                                    :arrayChilds="nav[n-1].arrayChilds"
                                    :minorScopes="nav[n-1].minorScopes"
                                    :componentHeader="nav[n-1].componentHeader"
                                    :disableNewItem="nav[n-1].disableNewItem"
                                    :enableImport="nav[n-1].enableImport"
                                    :headers="nav[n-1].headers"
                                    :subHeaders="nav[n-1].subHeaders"
                                    :expand="nav[n-1].expand"
                                    :maxWidthForm="nav[n-1].maxWidthForm"
                                    :maxWidthFormImport="nav[n-1].maxWidthFormImport"
                                    :itemModel="nav[n-1].itemModel"
                                    :inputs="nav[n-1].inputs"
                                    :inputsImport="nav[n-1].inputsImport"
                                    :optionExportPdf="nav[n-1].optionExportPdf"
                                />
                            </keep-alive>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs>
        </div>
    </div>
</template>

<script>
import PageTitle from '../templates/PageTitle'
import Register from '../register/Default'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('treports')

export default {
    name: 'ConsultPages',
    components: { PageTitle, Register },
    data: function() {
        return {
            nav: [
                {
                    title: 'Consultoria',
                    icon: "mdi-file-account",
                    path: 'consult',
                    query: 'limit=500',
                    scope: 'consult',
                    optionExportPdf: {
                        landscape: true,
                        columns: [
                            { header: 'Data', dataKey: 'createdAt' },
                            { header: 'Nome', dataKey: 'name' },
                            { header: 'E-mail', dataKey: 'mail' },
                            { header: 'Empresa', dataKey: 'company' },
                            { header: 'Telefone', dataKey: 'phone' },
                            { header: 'Curso', dataKey: 'course' },
                            { header: 'Mensagem', dataKey: 'message' },
                            { header: 'Status', dataKey: 'status' },
                            { header: 'Detalhe', dataKey: 'detail' },
                            { header: 'Ticket', dataKey: 'ticket' },
                        ]
                    },
                    headers: [
                        { text: 'ID', value: '_id', options: { slice: -6, toUpperCase: true } },
                        { text: 'Data', value: 'createdAt', options: { datePlusWeek: 'datePlusWeek' } },
                        { text: 'Nome', value: 'name', options: {} },
                        { text: 'E-mail', value: 'mail', options: {copy: true} },
                        { text: 'Empresa', value: 'company', options: {} },
                        { text: 'Telefone', value: 'phone', options: {} },
                        { text: 'Curso', value: 'course', options: {} },
                        { text: 'Status', value: 'status', options: {} },
                        { text: 'Detalhe', value: 'detail', options: {} },
                        { text: 'Ticket', value: 'ticket', options: {copy: true} },
                        { 
                            text: 'Ações', 
                            value: 'actions', 
                            sortable: false, 
                            align: 'center', 
                            options: { 
                                tdClass: 'text-center', 
                            } 
                        }
                    ],
                    maxWidthForm: 60,
                    inputs: [
                        { 
                            vType: 'v-subheader', 
                            content: 'Dados da Solicitação',
                            class: 'xs12 sm12 md12 lg12 xl12 pa-0 ma-0 font-weight-bold indigo--text text--darken-4',  
                        },
                        { 
                            vType: 'v-divider', 
                            class: 'xs12 sm12 md12 lg12 xl12 pa-0 ma-0', 
                        },
                        { 
                            vType: 'v-text-field', 
                            label: 'Nome', 
                            vModel: 'name', 
                            required: true,
                            class: 'xs12 sm12 md12 lg12 xl12', 
                        },
                        { 
                            vType: 'v-menu', 
                            label: 'Data', 
                            vModel: 'createdAt', 
                            required: true,
                            class: 'xs12 sm12 md4 lg4 xl4', 
                        },
                        { 
                            vType: 'v-text-field', 
                            label: 'Empresa', 
                            vModel: 'company', 
                            required: true,
                            class: 'xs12 sm12 md4 lg4 xl4', 
                        },
                        { 
                            vType: 'v-text-field', 
                            label: 'E-mail', 
                            vModel: 'mail', 
                            required: true,
                            class: 'xs12 sm12 md4 lg4 xl4', 
                        },
                        { 
                            vType: 'v-text-field', 
                            label: 'Telefone', 
                            vModel: 'phone', 
                            required: true,
                            class: 'xs12 sm12 md4 lg4 xl4', 
                        },
                        { 
                            vType: 'v-text-field', 
                            label: 'Celular', 
                            vModel: 'mobile', 
                            required: true,
                            class: 'xs12 sm12 md4 lg4 xl4', 
                        },
                        { 
                            vType: 'v-text-field', 
                            label: 'Curso', 
                            vModel: 'course', 
                            required: true,
                            class: 'xs12 sm12 md4 lg4 xl4', 
                        },
                        { 
                            vType: 'v-textarea', 
                            label: 'Conte-nos um pouco sobre a necessidade da sua empresa:', 
                            vModel: 'message', 
                            required: true,
                            dense: true,
                            class: 'xs12 sm12 md12 lg12 xl12', 
                        },
                        { 
                            vType: 'v-subheader', 
                            content: 'Controle Interno',
                            class: 'xs12 sm12 md12 lg12 xl12 pa-0 ma-0 font-weight-bold indigo--text text--darken-4',  
                        },
                        { 
                            vType: 'v-divider', 
                            class: 'xs12 sm12 md12 lg12 xl12 pa-0 ma-0', 
                        },
                        { 
                            vType: 'v-text-field', 
                            label: 'Ticket', 
                            vModel: 'ticket', 
                            required: true,
                            class: 'xs12 sm12 md6 lg6 xl6', 
                        },
                        { 
                            vType: 'v-select', 
                            label: 'Status', 
                            vModel: 'status', 
                            items: 'status', 
                            key: '_id', 
                            required: true, 
                            class: 'xs12 sm12 md6 lg6 xl6',
                        },
                        { 
                            vType: 'v-textarea', 
                            label: 'Detalhe:', 
                            vModel: 'detail', 
                            required: true,
                            dense: true,
                            class: 'xs12 sm12 md12 lg12 xl12', 
                        },
                    ]
                },
            ]
        }
    },
    computed: {
        ...mapGetters(['tabActived']),
        
        tabActived: {
			get () {
				return this.$store.state.registers.tabActived
			},
			set (value) {
				this.$store.commit('registers/setTabActived', value)
			}
		},
    },
}
</script>

<style>

</style>